type AppDeepLinkPayload = {
    advertising?: boolean;
    distributionPartner?: string;
    matrixLocation?: {
        numberOfColumns: number | null;
        numberOfRows: number | null;
        placementColumn: number | null;
        placementRow: number | null;
    };
    placement?: string;
    placementDetails?: string;
    referrer: string;
};


export default function appDeepLinkHandler(): AppDeepLinkPayload | null {
    const payload: AppDeepLinkPayload = {
        referrer: document.referrer
    };

    const { searchParams } = new URL(window.location.href);

    if (searchParams.has('placement')) {
        payload.placement = searchParams.get('placement') || '';
    }

    if (searchParams.has('placementDetails')) {
        payload.placementDetails = searchParams.get('placementDetails') || '';
    }

    if (searchParams.has('distributionPartner')) {
        payload.distributionPartner = searchParams.get('distributionPartner') || '';
    }

    if (searchParams.has('advertising')) {
        payload.advertising = (searchParams.get('advertising') === 'true');
    }

    const numberOfColumns = searchParams.get('numberOfColumns');
    const numberOfRows = searchParams.get('numberOfRows');
    const placementColumn = searchParams.get('placementColumn');
    const placementRow = searchParams.get('placementRow');

    if (numberOfRows || numberOfColumns || placementRow || placementColumn) {
        payload.matrixLocation = {
            numberOfColumns: numberOfColumns ? parseInt(numberOfColumns, 10) : null,
            numberOfRows: numberOfRows ? parseInt(numberOfRows, 10) : null,
            placementColumn: placementColumn ? parseInt(placementColumn, 10) : null,
            placementRow: placementRow ? parseInt(placementRow, 10) : null
        };
    }

    return payload;
}
